<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <v-card>
      <v-card-text>
        <h3 class="mb-4">Gauti pranešimai</h3>

        <savitarna-pranesimai-search
          :loading="loading"
          @search="searchSavitarnaPranesimai"
        />

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filterItemList"
          :search="search"
          :item-class="rowClass"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: 'Rodyti po:',
            itemsPerPageAllText: 'visi',
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :hide-default-footer="hideFooter"
          :sort-by.sync="pagination.sort"
          :sort-desc.sync="pagination.sortDesc"
          :server-items-length="pagination.total"
          :items-per-page="pagination.pageSize"
          :page.sync="pagination.page"
          @update:options="updatePagination"
        >
          <template #[`item.dokumentai`]="{ item }">
            <div class="font-normal">
              <el-byla
                v-for="byla in item.bylos"
                :key="byla.byl_id"
                :byla="byla"
                with-name
                @bylaOpen="setSeen(item)"
              />
            </div>
          </template>
          <template #[`item.actions`]="{ item }">
            <div class="nowrap">
              <el-table-action :item="item" @viewItem="editItem(item)" />
            </div>
          </template>
          <template slot="loading">
            Kraunasi...
          </template>
          <template slot="no-results">
            Duomenų nėra
          </template>
          <template slot="no-data">
            Duomenų nėra
          </template>
          <template #[`footer.page-text`]="props">
            Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import rowClass from '../../mixins/rowClass'
import SavitarnaPranesimaiSearch from './SavitarnaPranesimaiSearch'

export default {
  name: 'SavitarnaPranesimai',
  mixins: [rowClass],
  components: {
    SavitarnaPranesimaiSearch,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      headers: [
        {
          text: 'Pranešimo numeris',
          align: 'start',
          value: 'zus_numeris',
        },
        {
          text: 'Pranešimo data',
          align: 'start',
          value: 'pranesimo_data',
        },
        {
          text: 'Gauto pranešimo rūšis',
          align: 'start',
          value: 'dokumento_rusis',
        },
        {
          text: 'Dokumentai',
          align: 'start',
          value: 'dokumentai',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      lockInterval: null,
      lockTimeout: 10000,
      searchData: {},
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),

    filterItemList() {
      return this.pranesimai.map(pranesimas => {
        pranesimas.canView = true
        pranesimas.not_seen = !pranesimas.zus_perziuretas
        pranesimas.bylos = pranesimas.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: pranesimas.zus_numeris,
          }
        })

        return pranesimas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    isLocked() {
      return this.pranesimai.filter(item => item.obj_uzrakinta).length > 0
    },
  },
  created() {
    this.loading = true
    this.pageloading = true
    // this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`pranesimas/gauti-pranesimai`, data)
        .then(res => {
          this.pranesimai = res.data.zurnalas_siunciami
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchSavitarnaPranesimai(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    editItem(item) {
      this.setSeen(item)
      if (item.obj_id) {
        const objektasID = item.obj_id
        this.$store.dispatch('objektasID', objektasID).then(
          this.$store.dispatch('hipotekaTipas', item.zug_obj_tipas).then(
            this.$router.push({
              name: 'hipotekaRegistravimas',
              params: {
                objektasID: objektasID,
              },
            })
          )
        )
        return
      }
      if (item.pai_id) {
        this.$store
          .dispatch('searchParams', {
            route: 'savPaieskaMano',
            mainData: {},
            extraData: {
              pai_numeris: `${item.pai_id}`,
            },
            isExpanded: 1,
          })
          .then(
            this.$router.push({
              name: 'savPaieskaMano',
            })
          )
        return
      }

      window._VMA.$emit(
        'DATA_ERROR',
        'Šis pranešimas buvo pašalintas, dėl to jo peržiūra nėra galima.'
      )
    },
    setSeen(item) {
      this.$axios
        .post(`pranesimas/${item.zus_id}/perziuretas`)
        .then(res => {
          //
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          item.zus_perziuretas = true
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.font-normal {
  font-weight: 100 !important;
}
</style>
